module.exports = __webpack_public_path__ + "static/img/member19.4719f8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member19.jpg
// module id = SwbB
// module chunks = 0